<div class="fadeIn">
  <div class="clearfix">
    <a class="btn btn-link pull-right" href="javascript:void(0)" (click)="handleCloseOverlay()">{{ appCopy.panelHeader['skipText'+selectedLanguage] }} </a>
  </div>

  <h3>{{ appCopy.panelHeader['welcomeBackText'+selectedLanguage] }} {{ userName }}!</h3>
  <p class="margin-bottom-16">{{ appCopy.panelHeader['pleaseEnterPasswordText'+selectedLanguage] }}</p>

  <form #formLogin="ngForm" name="formLogin" (submit)="handleLogin(password.value, $event)" novalidate>
    <div class="form-group">
      <input class="form-control"
        id="Password"
        name="Password"
        [type]="maskPassword ? 'password' : 'text'"
        #password="ngModel"
        autocomplete="off"
        ngModel
        alert-caps-lock
        appCheckEmpty>
      <label class="control-label" for="Password">{{ appCopy.panelHeader['passwordLabel'+selectedLanguage] }}</label>
      <a class="control-btn" href="javascript:void(0)" (click)="maskPassword = !maskPassword">
        <i class="icon">view</i>
      </a>
    </div>

    <button type="submit" [ngClass]="{'Buttonloading' : showLoader}" class="btn btn-primary btn-lg btn-block margin-bottom-16">
      <!-- <div class="loader-container-btn" *ngIf="showLoader">
        <div class="loader loader--white">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" />
          </svg>
        </div>
      </div> -->
      {{ !showLoader && appCopy.panelHeader['bookFromText'+selectedLanguage] }} {{showCurrencyWithPrice}}
    </button>
  </form>
  <p class="text-center"><a class="link" href="javascript:void(0)" (click)="showNoPasswordLogin()">{{ appCopy.panelHeader['dontKnowYourPasswordText'+selectedLanguage] }}</a></p>
</div>
